import { Layout } from '../components/Layout/Layout';
import { TestAlarm } from '../components/SidebarOptions/TestAlarm/TestAlarm';

export const TestAlarmPage = () => {
  return (
    <Layout isMessageLayout message="alarm_test_screen" to="/sidebar" showBottomTabs>
      <TestAlarm />
    </Layout>
  );
};
